import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import Meta from 'vue-meta';
import Vuelidate from 'vuelidate'
import App from './App.vue';
import router from './router';
import NowUiKit from './plugins/now-ui-kit';
import i18n from '@/lang/i18n';

// Vuetify
import vuetify from '@/plugins/vuetify'


import VueSignaturePad from 'vue-signature-pad';

Vue.config.productionTip = false;

Vue.use(VueSignaturePad);
Vue.use(Meta)
Vue.use(Vuelidate)
Vue.use(NowUiKit)

new Vue({
  router,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app');
